import { Run, Task, User } from '@bringg/types';

export interface UserAssignmentData {
	tasksRunIds?: number[];
	drivers: User[];
	doNotNotifyServerOnAssign?: boolean;
	allowedActions?: string[];
	isSavedRun?: boolean;
}

type BasicProps = {
	isAllRunWasSelected: boolean;
};

export interface PropsWithRoute extends BasicProps {
	run: Run;
	runTasks: Task[];
	tasks?: Task[];
	selectedTasksWeight?: { maxWeight: number; weightCapacity: number };
}

export interface PropsWithTasks extends BasicProps {
	run?: Run;
	runTasks?: Task[];
	tasks: Task[];
	selectedTasksWeight: { maxWeight: number; weightCapacity: number };
}

export type SourceData = PropsWithRoute | PropsWithTasks;

export interface UserAssignmentModalParams {
	source: SourceData;
	readyToExecute: boolean;
	data: UserAssignmentData;
}

export type ViewNames = 'table' | 'newRoute' | 'optimizationView';

export enum actions {
	assign = 'assign',
	unassign = 'unassign',
	merge = 'merge',
	new_route_creation = 'new_route_creation'
}

export const assignSuccessMessage = 'RUN_USER_ASSIGNMENT.ASSIGN_SUCCESS';
export const assignErrorMessage = 'RUN_USER_ASSIGNMENT.ASSIGN_ERROR';

export interface CloseDataType {
	targetRunId: number | undefined;
	driver: User;
}
export const getCloseData = (targetRunId: number | undefined, drivers: User[], driverId: number): CloseDataType => {
	return {
		targetRunId,
		driver: drivers.find(driver => driver.id === driverId)
	};
};
